<template>
    <!-- 开题报告 -->
    <div class="replyMain">
        <p class="introduce">说明：</p>
        <p class="introduce" v-for="item in thesisBindingMaterialList">{{ item.remark }}</p>
        <el-form ref="form" :model="form" label-width="100px" class="replyform">
            <el-form-item label="胶装材料:">
                <span style="float:left;margin-right:20px;">
                    <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers" :show-file-list="false"
                        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :disabled="disabledset">
                        <span>{{ form.bindingMaterialFileName }}</span>
                        <el-button size="small" type="primary" :disabled="disabledset">点击上传</el-button>
                    </el-upload>
                </span>
                <span style="color: red;">⚠️请将所有文件打包成一个压缩包一并上传</span>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save" :disabled="disabledset">提交</el-button>
                <span style="color: red;">{{ endMsg }}</span>
            </el-form-item>
        </el-form>
        <el-row>
            <p>胶装材料审核记录</p>
            <el-table :data="recordData" border style="width: 100%">
                <el-table-column align="center" prop="uploadFileName" label="文件名称">
                </el-table-column>
                <el-table-column align="center" prop="approveTeacherName" label="指导老师">
                </el-table-column>
                <el-table-column align="center" prop="approveFileName" label="老师指导附件">
                    <template slot-scope="scope">
                        <span @click="getFile(scope.row.approveFileUrl,'胶装材料老师审核.docx')" style="color:#1890ff;cursor:pointer">{{
                            scope.row.approveFileName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="approveStatusText" label="审批状态">
                </el-table-column>
                <el-table-column align="center" prop="approveOpinion" label="老师指导意见">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
import { getCookieForRoleTag } from '../../../common/ulit'
export default {
    name: "bindingMaterial",
    data() {
        return {
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
            thesisRecord: {}, //提交内容
            recordData: [], //审核记录
            state: 0, //0  1  2  3未提交  未审批 驳回修改   完成  
            disabledset: false,
            form: {
                bindingMaterialFileUrl: '',
                bindingMaterialFileName: '',
            },
            thesisBindingMaterialList: [],  //胶装材料描述列表
            endMsg: '', //超过截止时间msg
            bindingMaterialDead: false, //是否超过截止时间

        }
    },
    mounted() {
        this.getThesisBindingMaterialList();
        this.recordDataset();
        this.deadlineFunction();
    },
    methods: {
        deadlineFunction() {
            let param = {}
            this.$store.dispatch("thesis/getDeadline", param).then((ret) => {
                if (ret.code == 0) {
                    this.bindingMaterialDead = ret.data.bindingMaterialDead;
                    if (this.bindingMaterialDead == true) {
                        this.disabledset = true
                        this.endMsg = '已超过截止时间，无法提交'
                    }
                } else {
                    this.$message.error(ret.msg);
                }
            })
        },
        getThesisBindingMaterialList() {
            this.$store.dispatch("thesis/thesisBindingMaterialList").then((ret) => {
                if (ret.code == 0) {
                    this.thesisBindingMaterialList = ret.data
                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {

            });
        },
        recordDataset(thesisRecordId) {
            let param = {
                thesisRecordId: thesisRecordId
            }
            this.$store.dispatch("thesis/getThesisCheckDetailByParam", param).then((ret) => {
                if (ret.code == 0) {
                    this.thesisRecord = ret.data.thesisRecord
                    this.recordData = ret.data.thesisApproveList.filter((item) => {
                        return item.thesisStatus == 10
                    })  //审核记录
                    let thesisStatus = ret.data.thesisRecord.thesisStatus
                    console.log("thesisStatus", thesisStatus)
                    if (thesisStatus != 10) {
                        this.state = 3
                        this.disabledset = true
                    } else if (thesisStatus == 10) {
                        if (this.thesisRecord.isReject == 0) {
                            this.state = 1

                        } else { //驳回
                            this.state = 2
                        }

                    }
                    if (thesisStatus != 10) {
                        this.disabledset = true
                    }

                    /* 内容回显 */
                    this.form.thesisRecordId = this.thesisRecord.id
                    this.form.bindingMaterialFileName = this.thesisRecord.bindingMaterialFileName
                    this.form.bindingMaterialFileUrl = this.thesisRecord.bindingMaterialFileUrl

                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {

            });
        },
        beforeAvatarUpload(file) {

        },
        handleAvatarSuccess(res, tag) {
            if (res.code == 0) {
                this.form.bindingMaterialFileName = res.data.title
                this.form.bindingMaterialFileUrl = res.data.url
            }
        },
        save() {
            if (this.state == 2) { //编辑
                let param = {
                    thesisRecordId: this.form.thesisRecordId,
                    bindingMaterialFileName: this.form.bindingMaterialFileName,
                    bindingMaterialFileUrl: this.form.bindingMaterialFileUrl,
                }
                this.$store.dispatch("thesis/editBindingMaterial", param).then((ret) => {
                    if (ret.code == 0) {
                        this.$message({
                            showClose: true,
                            message: '胶装材料修改成功',
                            type: 'success'

                        });
                        this.disabledset = true
                    } else {
                        this.$message.error(ret.msg);
                    }
                }).catch((err) => {
                });
            } else {//新增
                let param = {
                    thesisRecordId: this.form.thesisRecordId,
                    bindingMaterialFileName: this.form.bindingMaterialFileName,
                    bindingMaterialFileUrl: this.form.bindingMaterialFileUrl,
                }
                // debugger
                this.$store.dispatch("thesis/commitBindingMaterial", param).then((ret) => {
                    if (ret.code == 0) {
                        this.$message({
                            showClose: true,
                            message: '胶装材料提交成功',
                            type: 'success'

                        });
                        this.disabledset = true
                    } else {
                        this.$message.error(ret.msg);
                    }
                }).catch((err) => {
                });
            }
        },
        //附件下载
        getFile(url, name) {
            const a = document.createElement("a");
            const prefix = window.configs.API_ROOT;
            let setturl=prefix+url
            fetch(setturl)

                .then((res) => res.blob())

                .then((blob) => {

                    // 将链接地址字符内容转变成blob地址

                    a.href = URL.createObjectURL(blob);

                    a.download = name; // 下载文件的名字

                    // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字

                    document.body.appendChild(a);

                    a.click();

                    document.body.removeChild(a);

                })

        }

    }
}
</script>
<style  lang="less">
.replyMain {
    padding: 15px;

    .introduce {
        color: red;
        margin-bottom: 10px;
    }

    .replyform {
        width: 868px;
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/transactionPaper/writeGroup/bindingMaterial.vue